module.exports = __webpack_public_path__ + "img/fileType_img.5f5c45f5.svg";